import useCallSettings from './use-call-settings';
import ValidatePhoneModal from './validate-phone-modal';
import RemoveVoipPhoneButton from './remove-voip-phone-button';
import ControlledMaskedInput from 'components/forms/controlled-masked-input';
import { useGlobalOutreachProvider } from 'apps/outreach/contexts/global-outreach-context';
import { PageHeader, Button, useOpenClose } from '@evertrue/et-components';

const PhoneSettingsForm = () => {
  const {
    callerIdNumber,
    setCallerIdNumber,
    validatePhoneNumber,
    validationCode,
    handleCloseModal,
    extension,
    setExtension,
  } = useCallSettings();
  const [isValidationModalOpen, openValidationModal, closeValidationModal] = useOpenClose();
  const { hasVoip } = useGlobalOutreachProvider();

  const handleVerify = async () => {
    await validatePhoneNumber(callerIdNumber, openValidationModal, extension);
  };

  const handleClose = async () => {
    await handleCloseModal(closeValidationModal);
  };

  const clearInputs = () => {
    setCallerIdNumber('');
    setExtension('');
  };

  return (
    <>
      <PageHeader title="Phone" className="outreach-settings-header" />
      {!hasVoip ? (
        <div className="voip-error-message">
          Please contact your EverTrue customer success manager or implementation partner for assistance with setting up
          your phone settings.
        </div>
      ) : (
        <>
          <p>Custom Caller ID Number</p>
          <p>
            This number will appear on the call recipient’s caller ID in place of your EverTrue number. To use this
            feature you must verify that you own the number entered here. Please be sure to complete steps requested and
            end the call before closing the pop-up verification code window.
          </p>
          <p>This is required in order to use phone features within EverTrue.</p>
          <div style={{ display: 'flex', width: '400px' }}>
            <ControlledMaskedInput
              placeholder="(111) 111-1111"
              placeholderChar="|"
              value={callerIdNumber}
              onChange={(number) => setCallerIdNumber(number)}
              mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              className="phone-number-input"
            />
            <ControlledMaskedInput
              placeholder="ext."
              placeholderChar="|"
              value={extension}
              onChange={(number) => setExtension(number)}
              mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
              className="phone-extension-input"
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: '10px',
            }}
          >
            <Button onClick={handleVerify}>Verify Number</Button>
            <RemoveVoipPhoneButton clearInputs={clearInputs} />
          </div>

          <ValidatePhoneModal code={validationCode} isOpen={isValidationModalOpen} onClose={handleClose} />
        </>
      )}
    </>
  );
};

export default PhoneSettingsForm;
